import { AfterViewInit, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { SorteioService } from '../../../publico/sorteios/shared/sorteio.service';
import { SorteioEspecialModel } from '../../../shared/model/sorteio-especial';
import { SorteioModel } from '../../../shared/model/sorteio.model';
import { BilheteConsumidorModel } from '../shared/consumidor-bilhetes.model';
import { BilheteConsumidorService } from '../shared/consumidor-bilhetes.service';
import { AgrupamentoMensalBilheteModel } from '../../../shared/model/agrupamento-mensal-bilhete.model';
import { DetalheAgrupamentoMensalBilheteModel } from '../../../shared/model/detalhe-agrupamento-mensal-bilhete.model';
import { SituacaoConsumidorReferenciaSorteioModel } from '../shared/situacao-consumidor-referencia-sorteio.model';
import { SituacaoConsumidorReferenciaSorteioService } from '../shared/situacao-consumidor-referencia-sorteio.service';
import { FiltroBuscaSituacaoConsumidorReferenciaSorteio } from '../../../shared/filter/filtro-busca-situacao-consumidor-referencia-sorteio';
import { FiltroListagemBilhetesComPrevisao } from '../../../shared/model/filtro-listagem-bilhetes-com-previsao';


@Component({
  selector: 'app-consumidor-bilhetes',
  templateUrl: './consumidor-bilhetes.component.html',
  encapsulation: ViewEncapsulation.None
})
export class ConsumidorBilhetesComponent implements OnInit, AfterViewInit  {

  meses = [
    { valor: 1, nome: 'Janeiro ' },
    { valor: 2, nome: 'Fevereiro ' },
    { valor: 3, nome: 'Março ' },
    { valor: 4, nome: 'Abril ' },
    { valor: 5, nome: 'Maio ' },
    { valor: 6, nome: 'Junho ' },
    { valor: 7, nome: 'Julho ' },
    { valor: 8, nome: 'Agosto ' },
    { valor: 9, nome: 'Setembro ' },
    { valor: 10, nome: 'Outubro ' },
    { valor: 11, nome: 'Novembro ' },
    { valor: 12, nome: 'Dezembro ' }
  ];

  anos = [];

  // Mensal
  public ahPrevisaoMensal = false;
  public totalBilhetesMensal = 0;
  public QuantidadePrevisaoBilhetesMensal = 0;
  public bilhetesMensal: BilheteConsumidorModel[] = undefined;
  public bilheteMensal: BilheteConsumidorModel = undefined;
  public quantidadeBilhetesAtualConsumidorMensal: number = 0;
  public nomeSorteioMensal : string;
  public paginaMensal = 1;
  public tamanhoPaginaMensal = 10;
  public mensagemErroMensal = null;
  public bilhetesGeradosMensal: boolean;
  public seqSorteioMensal = 0;

  public MensagemErroGeralMensal: string;
  public MensagemErroGeralEspecial: string;

  // Especial
  public ahPrevisaoEspecial = false;
  public totalBilhetesEspecial = 0;
  public QuantidadePrevisaoBilhetesEspecial = 0;
  public bilhetesEspecial: BilheteConsumidorModel[] = undefined;
  public nomeSorteioEspecial : string;
  public paginaEspecial = 1;
  public tamanhoPaginaEspecial = 10;
  public mensagemErroEspecial = null;
  public bilhetesGeradosEspecial: boolean;
  public total_geral_bilhetes: number = -1;

  // Booleans para controlar a exibição da mensagem de que o consumidor está/Estava impedido no período do Sorteio
  public consumidorImpedidoMensal: boolean;
  public consumidorImpedidoEspecial: boolean;

  public ano = 0;
  public mes = 0;
  public bilheteMensalConsumidorForm: FormGroup;
  public bilheteEspecialConsumidorForm: FormGroup;

  public listaSorteiosEspeciais: Array<SorteioEspecialModel>;
  public listaAgrupamentoMensalBilhete: Array<AgrupamentoMensalBilheteModel>;

  public listaDetalheAgrupamentoMensalBilhete: DetalheAgrupamentoMensalBilheteModel[] = [];
  public descricaoSituacaoSorteioEspecial:string ='';
  public dataSorteioEspecial: Date;
  public situacaoConsumidorSorteio: SituacaoConsumidorReferenciaSorteioModel;
  public sorteioModel: SorteioModel;

  constructor(
    private readonly fb: FormBuilder,
    private readonly bilheteConsumidorMensalService: BilheteConsumidorService,
    private readonly bilheteConsumidorService: BilheteConsumidorService,
    private readonly sorteioService: SorteioService,
    private readonly situacaoConsumidorReferenciaSorteioService: SituacaoConsumidorReferenciaSorteioService) {}

  ngOnInit() {

    this.listaAgrupamentoMensalBilhete = [];

    // Preenche object "anos = []" com a lista de anos.
    this.preencherListagemAno();

    // Inicializa o form
    this.inicializaForm();

    // Carregar os sorteios especiais
    this.obterSorteiosEspeciais();

    this.getSorteiosEspeciais();

    this.UpdateMessagemErroGeralMensal();
    this.UpdateMessagemErroGeralEspecial();
  }

  private UpdateMessagemErroGeralMensal() {
    this.bilheteConsumidorService.currentMessageMensal.subscribe(message => this.MensagemErroGeralMensal = message)
  }

  private UpdateMessagemErroGeralEspecial() {
    this.bilheteConsumidorService.currentMessageEspecial.subscribe(message => this.MensagemErroGeralEspecial = message)
  }

  ngAfterViewInit(): void {

       // Obtém os bilhetes do cidadão.
       this.obterBilhetesComPrevisaoMensal();
  }

  private obterSorteiosEspeciais() {
    this.sorteioService.sorteiosEspeciaisChange.subscribe(
      (data: Array<SorteioEspecialModel>) => {
        this.listaSorteiosEspeciais = data;
      },
      erro => {
        console.log(erro.message);
      },
      () => {}
    );
  }

  private obterAgrupamentoMensalBilhete() {
    this.bilheteConsumidorService.ListagemAgrupamentoMensalBilheteChange.subscribe(
      (data: Array<AgrupamentoMensalBilheteModel>) => {
        this.listaAgrupamentoMensalBilhete = data;

        this.total_geral_bilhetes = 0;

        this.listaAgrupamentoMensalBilhete.forEach( (element) => {
          element.flagMostrarBilhetes = false;
          this.total_geral_bilhetes = this.total_geral_bilhetes + element.total_bilhetes;
      });



      },
      erro => {
        console.log(erro.message);
      },
      () => {}
    );
  }

  private obterDetalheAgrupamentoMensalBilhete() {

    this.listaDetalheAgrupamentoMensalBilhete = [];

    this.bilheteConsumidorService.ListagemDetalheAgrupamentoMensalBilheteChange.subscribe(
      (data: Array<DetalheAgrupamentoMensalBilheteModel>) => {
        this.listaDetalheAgrupamentoMensalBilhete = data;
      },
      erro => {
        console.log(erro.message);
      },
      () => {}
    );
  }


    public verificarSituacaoConsumidorSorteio(TipoSorteio: number , IdSorteio: number) {

      //  Tipo Sorteio premiação consumidor
      //  1	- Mensal
      //  2	- Especial

      let ConsumidorId = JSON.parse(localStorage.getItem('consumidor'))['consumidorId'];

      let filtroBuscaSituacaoConsumidorReferenciaSorteio = new  FiltroBuscaSituacaoConsumidorReferenciaSorteio(ConsumidorId,IdSorteio);

      if (IdSorteio > 0) {
          const s: Subscription = this.situacaoConsumidorReferenciaSorteioService.getSituacaoConsumidorReferenciaSorteio(filtroBuscaSituacaoConsumidorReferenciaSorteio)
            .subscribe((data: SituacaoConsumidorReferenciaSorteioModel) => {
              s.unsubscribe();

                this.situacaoConsumidorSorteio = data;
                if (this.situacaoConsumidorSorteio.statusParticipanteSorteio == 1) {
                  if (TipoSorteio == 1) {
                    this.consumidorImpedidoMensal = false;
                  } else {
                    this.consumidorImpedidoEspecial = false;
                  }
                } else {
                  if (TipoSorteio == 1) {
                    this.consumidorImpedidoMensal = true;
                  } else {
                    this.consumidorImpedidoEspecial = true;
                  }
                }

            }, error => {
              s.unsubscribe();
            });
      }
    }

    private obterBilhetesComPrevisaoMensal() {
    
      let filtro = new FiltroListagemBilhetesComPrevisao();
      filtro.ano = this.bilheteMensalConsumidorForm.controls['ano'].value;
      filtro.mes = this.bilheteMensalConsumidorForm.controls['mes'].value;
      filtro.page = this.paginaMensal;
      filtro.pageSize = this.tamanhoPaginaMensal;
      filtro.tipoSorteio = 1;

      this.bilheteConsumidorMensalService.getListaBilhetesComPrevisaoMensal(filtro);

      const s: Subscription = this.bilheteConsumidorMensalService.bilhetesMensalChange.subscribe(
        (data: Array<BilheteConsumidorModel>) => {

          this.totalBilhetesMensal = this.bilheteConsumidorMensalService.totalBilhetesMensal;
          this.QuantidadePrevisaoBilhetesMensal = this.bilheteConsumidorMensalService.previsaoBilhetesMensal;
          this.bilhetesMensal = this.bilheteConsumidorMensalService.bilhetesMensal;
          this.nomeSorteioMensal = this.bilheteConsumidorMensalService.nomeSorteioMensal;
          this.bilhetesGeradosMensal = this.bilheteConsumidorMensalService.bilhetesGeradosMensal;


          if(this.QuantidadePrevisaoBilhetesMensal > 0) {
          this.ahPrevisaoMensal = true;
          this.quantidadeBilhetesAtualConsumidorMensal = 0;

          } else {
            this.ahPrevisaoMensal = false;
            this.quantidadeBilhetesAtualConsumidorMensal = this.totalBilhetesMensal;
          }

        // Verificação da situação do consumidor no período do sorteio mensal
        // O Id do sorteio é obtido através dos registros dos bilhetes retornados na consulta
        // Com o ID do Sorteio (seq_sorteio_premiacao_consumidor) se obtem a informação da situação.
        if (this.bilhetesMensal) {
            if (this.quantidadeBilhetesAtualConsumidorMensal > 0) {
              this.seqSorteioMensal = this.bilhetesMensal[0].seq_sorteio_premiacao_consumidor;
              if (this.seqSorteioMensal  > 0) {
                this.verificarSituacaoConsumidorSorteio(1,this.seqSorteioMensal);
              }
            }
          }

        },
        erro => {
          s.unsubscribe();      
        },
        () => {

          s.unsubscribe();
        }
      );
    }

  pesquisarMensal() {

    this.paginaMensal = 1;
    this.consumidorImpedidoMensal = false;
   // Obtém os bilhetes do cidadão.
   this.obterBilhetesComPrevisaoMensal();
  }

  pesquisarEspecial() {
    this.consumidorImpedidoMensal = false;
    // Obtém a listagem do Agrupamento Mensal dos bilhetes do Consumidor.
    let sorteioId: number = this.bilheteEspecialConsumidorForm.controls['sorteioEspecial'].value;

    this.descricaoSituacaoSorteioEspecial = this.listaSorteiosEspeciais.find(i => i.seqSorteio == sorteioId).situacao;
    this.dataSorteioEspecial = this.listaSorteiosEspeciais.find(i => i.seqSorteio == sorteioId).dataRealizacao;

    if (this.dataSorteioEspecial == null) {
      this.dataSorteioEspecial = this.listaSorteiosEspeciais.find(i => i.seqSorteio == sorteioId).dataPrevista;
    }

    if (this.listaSorteiosEspeciais.find(i => i.seqSorteio == sorteioId).codSituacao == 5) {
      this.dataSorteioEspecial = null;
    }

    this.obterAgrupamentoMensalBilhete();
    this.getAgrupamentoMensalBilhete(sorteioId);
    this.verificarSituacaoConsumidorSorteio(2,sorteioId);
  }

  pesquisarDetalhe(ano: number, mes: number){

    this.listaAgrupamentoMensalBilhete.forEach( (element) => {
      if (element.ano != ano || element.mes != mes) {
        element.flagMostrarBilhetes = false;
      }
    });

    this.obterDetalheAgrupamentoMensalBilhete();
    this.getDetalheAgrupamentoMensalBilhete(ano, mes);
  }

  // Preenche Lista com os Anos
  preencherListagemAno() {
    const cargaAnos = new Date();
    const anoBase = cargaAnos.getFullYear() - 5;
    for (let index = 0; index < 10; index++) {
      this.anos.push(anoBase + index);
    }
  }


  inicializaForm() {
    this.bilheteMensalConsumidorForm = this.fb.group({
      ano: [this.obterAnoSorteioMensalAtual()],
      mes: [this.obterMesSorteioMensalAtual()]
    });

    this.bilheteEspecialConsumidorForm = this.fb.group({
      'sorteioEspecial': []
    });
  }

  sortByDesc() {
    return this.listaSorteiosEspeciais.sort((a, b) => { return b.numeroSorteio - a.numeroSorteio });
  }

  public getSorteiosEspeciais(): void {
    this.sorteioService.getSorteiosEspeciais();
  }

  public getAgrupamentoMensalBilhete(sorteioId: number): void {
    this.bilheteConsumidorService.getAgrupamentoMensalBilhete(sorteioId);
  }

  public getDetalheAgrupamentoMensalBilhete(ano: number, mes: number): void {
    this.bilheteConsumidorService.getDetalheAgrupamentoMensalBilhete(ano,mes);
  }

  private obterAnoSorteioMensalAtual() {
    return sessionStorage.getItem('ano_sorteio_mensal_atual');
  }

  private obterMesSorteioMensalAtual() {
    return sessionStorage.getItem('mes_sorteio_mensal_atual');
  }

  pageChangeMensal(event: number): void {

    this.paginaMensal = event;

    // Obtém os bilhetes do cidadão.
    this.obterBilhetesComPrevisaoMensal();
  }


}



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-bilhetes/consumidor-bilhetes.component.ts